import _typeof from "/home/jenkins/workspace/procure-web-seven-test/node_modules/@babel/runtime-corejs2/helpers/esm/typeof";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.is";
import "core-js/modules/es6.regexp.replace";
import router from "../../router";
import { Loading, Message } from "element-ui";
import Code from "./code";
import axios from "axios";
var needLoadingRequestCount = 0;
var LoadingObj = {
  loading: null,
  open: function open() {
    this.loading = Loading.service({
      lock: true,
      text: '数据加载中',
      background: 'rgba(0, 0, 0, 0.6)'
    });
  },
  close: function close() {
    this.loading.close();
  }
};
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    LoadingObj.open();
  }
  needLoadingRequestCount++;
}
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) {
    return;
  }
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    LoadingObj.close();
  }
}

// "请求" 拦截器,过滤重复的请求
axios.interceptors.request.use(function (config) {
  //发起请求时，取消掉当前正在进行的相同请求
  if (/(bird.ioliu.cn)|(wthrcdn.etouch)/.test(config.url)) {
    config.headers = null;
    return config;
  }
  var token = sessionStorage.getItem('token');
  if (token) {
    var tokenId = JSON.parse(token).tokenId.replace(/"/g, "");
    if (tokenId) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token

      config.headers.token = "".concat(tokenId);
    }
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// // 响应拦截器
axios.interceptors.response.use(function (response) {
  if (response.status == 302) {
    router.push("/");
  }
  return response;
}, function (error) {
  return Promise.reject(error);
});

/**
 * 增加其他的请求方式
 * @author Shanks
 */
// 增加统一配置
var request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API + '',
  responseType: 'json',
  timeout: 300000,
  //三百秒 管总要求新增
  validateStatus: function validateStatus(status) {
    // 200 外的状态码都认定为失败
    return status === 200;
  }
});
request.interceptors.request.use(function (config) {
  //发起请求时，取消掉当前正在进行的相同请求

  if (/(bird.ioliu.cn)|(wthrcdn.etouch)/.test(config.url)) {
    config.headers = null;
    return config;
  }
  console.log('router', router.path);
  var token = sessionStorage.getItem('token');
  if (token) {
    var tokenId = JSON.parse(token).tokenId.replace(/"/g, "");
    if (tokenId) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token

      config.headers.token = "".concat(tokenId);
    }
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// 响应拦截器
request.interceptors.response.use(function (res) {
  tryHideFullScreenLoading();
  return res;
}, function (error) {
  tryHideFullScreenLoading();
  console.log(error.code);
  if (error.code === 'ECONNABORTED') {
    // 超时错误处理
    Message({
      type: 'error',
      message: '请求超时，请稍后再试'
    });
  } else {
    var errorMessage = error.response.obj === null ? '系统内部异常，请联系网站管理员' : error.response.data.msg;
    switch (error.response.status) {
      case 404:
        Message({
          type: "error",
          message: "很抱歉，资源未找到"
        });
        break;
      case 403:
      case 401:
        Message({
          type: "error",
          message: "很抱歉，您无法访问该资源，可能是因为没有相应权限或者登录已失效"
        });
        break;
      default:
        Message({
          type: "error",
          message: errorMessage
        });
        break;
    }
  }
});
// 无正在加载动画  处理后端进行了全局异常处理定义的错误code
function handleCustomErrorCodeWithOutLoading(req) {
  return new Promise(function (resolve, refect) {
    req.then(function (res) {
      if (res.data.code == Code.successCode || res.data.code === '0') {
        resolve(res.data);
      } else if (res.data.code == Code.sessionErrorCode) {
        if (document.getElementsByClassName('el-message').length <= 0) {
          Message({
            type: "warning",
            message: res.data.userInfo
          });
        }
        sessionStorage.clear();
        localStorage.clear();
        router.push("/");
      } else {
        if (res.data.userInfo) {
          Message({
            type: 'error',
            message: res.data.userInfo
          });
        }
        throw res.data;
      }
    }).catch(function (error) {
      refect(error);
    });
  });
}
// 处理后端进行了全局异常处理定义的错误code
function handleCustomErrorCode(req) {
  return new Promise(function (resolve, refect) {
    var loading = Loading.service({
      lock: true,
      text: '数据加载中',
      background: 'rgba(0, 0, 0, 0.6)'
    });
    req.then(function (res) {
      loading.close();
      if (res.data.code == Code.successCode || res.data.code === '0') {
        resolve(res.data);
      } else if (res.data.code == Code.sessionErrorCode) {
        if (document.getElementsByClassName('el-message').length <= 0) {
          Message({
            type: "warning",
            message: res.data.userInfo
          });
        }
        sessionStorage.clear();
        localStorage.clear();
        router.push("/");
      } else {
        if (res.data.userInfo) {
          Message({
            type: 'error',
            message: res.data.userInfo
          });
        }
        throw res.data;
      }
    }).catch(function (error) {
      loading.close();
      refect(error);
    });
  });
}
var Rxports = {
  /**
   * 封装axios，减少学习成本，参数基本跟jq ajax一致
   * @param {boolean} showloading    是否显示loading默认是
   * @param {String} type            请求的类型，默认post
   * @param {String} url                请求地址
   * @param {String} time            超时时间
   * @param {Object} data            请求参数
   * @param {String} dataType        预期服务器返回的数据类型，xml html json ...
   * @param {Object} headers            自定义请求headers
   * @param {Function} success        请求成功后，这里会有两个参数,服务器返回数据，返回状态，[data, res]
   * @param {Function} error        发送请求前
   * @param return
   */
  ajax: function ajax(opt) {
    var opts = opt || {};
    if (!opts.url) {
      alert('请填写接口地址');
      return false;
    }
    opts.show == undefined ? showFullScreenLoading() : "hide";
    axios({
      method: opts.method || 'post',
      url: opts.url,
      showLoading: opts.show || 'show',
      params: opts.params || {},
      data: opts.data,
      headers: opts.headers || {},
      responseType: opts.responseType || "",
      // `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL。
      // 它可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
      // baseURL: 'http://localhost:8097/procure/',
      // baseURL: 'http://47.94.107.142:8097/procure/',
      // cancelToken: new CancelToken(c => {
      //   cancel = c
      // }),
      baseURL: opts.isChangeUrl ? process.env.VUE_APP_BASE_VEHICLE_API : process.env.VUE_APP_BASE_API,
      // baseURL:'http://user.construn.cn/user/',
      timeout: opts.time || 30 * 1000,
      // responseType: opts.dataType || 'json',
      validateStatus: function validateStatus(status) {
        return status < 300; //状态码小于400时均为成功（返回true）
      },
      success: opts.success,
      error: opts.error
    }).then(function (res) {
      tryHideFullScreenLoading();
      if (opts.responseType == "blob") {
        opts.success(res.data);
      }
      if (res.status == 302) {
        Message({
          type: "warning",
          message: res.data.userInfo
        });
        router.push("/");
      }
      if (res.data.code == Code.successCode || res.data.code === '0') {
        opts.success(res.data);
      } else if (res.data.code == Code.sessionErrorCode) {
        if (document.getElementsByClassName('el-message').length <= 0) {
          Message({
            type: "warning",
            message: res.data.userInfo
          });
        }
        sessionStorage.clear();
        localStorage.clear();
        router.push("/");
      } else if (res.data.hasOwnProperty("code")) {
        Message({
          type: "warning",
          message: res.data.userInfo
        });
      }
    }).catch(function (data) {
      // console.log(data.message)
      // loading.close();
      tryHideFullScreenLoading();
      if (data.response.status == 404) {
        Message({
          type: "warning",
          message: "资源未找到"
        });
      } else {
        Message({
          type: "error",
          message: "网络异常"
        });
      }
    });
  },
  get: function get(url, params) {
    var _params = '';
    if (Object.is(params, undefined)) {
      _params = '';
    } else {
      if (url.includes('?')) {} else {
        _params = '?';
      }
      for (var prop in params) {
        _params += "".concat(prop, "=").concat(params[prop], "&");
      }
    }
    return handleCustomErrorCode(request.get("".concat(url).concat(_params)));
  },
  getWithOutLoading: function getWithOutLoading(url, params) {
    var _params;
    if (Object.is(params, undefined)) {
      _params = '';
    } else {
      _params = '?';
      for (var prop in params) {
        _params += "".concat(prop, "=").concat(params[prop], "&");
      }
    }
    return handleCustomErrorCodeWithOutLoading(request.get("".concat(url).concat(_params)));
  },
  postJson: function postJson(url, params) {
    return handleCustomErrorCode(request.post(url, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    }));
  },
  postWithOutLoadingJson: function postWithOutLoadingJson(url, params) {
    return handleCustomErrorCodeWithOutLoading(request.post(url, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    }));
  },
  putJson: function putJson(url, params) {
    return handleCustomErrorCode(request.put(url, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    }));
  },
  // delete(url, params) {
  // 	let _params;
  // 	if (Object.is(params, undefined)) {
  // 		_params = '';
  // 	} else {
  // 		_params = '?';
  // 		for (let prop in params) {
  // 			_params += `${prop}=${params[prop]}`;
  // 		}
  // 	}
  // 	return handleCustomErrorCode(request.delete(`${url}${_params}`));
  // },
  delete: function _delete(url, params) {
    var _params = '';
    if (params && Object.keys(params).length > 0) {
      // 检查params是否存在且非空
      var paramArray = [];
      for (var prop in params) {
        // 仅处理自身属性（避免原型链污染）
        if (params.hasOwnProperty(prop)) {
          paramArray.push("".concat(prop, "=").concat(encodeURIComponent(params[prop]))); // 建议编码参数值
        }
      }
      if (paramArray.length > 0) {
        _params = '?' + paramArray.join('&'); // 用&连接所有参数
      }
    }
    return handleCustomErrorCode(request.delete("".concat(url).concat(_params)));
  },
  deleteList: function deleteList(url, ids) {
    return handleCustomErrorCode(request.delete(url, {
      data: ids
    }));
  },
  download: function download(url, filename, params) {
    if (_typeof(filename) === 'object') {
      params = filename;
    }
    return request.post(url, params, {
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    }).then(function (r) {
      var content = r.data;
      var blob = new Blob([content]);
      if ('download' in document.createElement('a')) {
        var elink = document.createElement('a');
        elink.download = filename;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      } else {
        navigator.msSaveBlob(blob, filename);
      }
    }).catch(function (r) {
      console.error(r);
      Message({
        type: "error",
        message: "下载失败"
      });
    });
  },
  getDownload: function getDownload(url, filename, params) {
    if (_typeof(filename) === 'object') {
      params = filename;
    }
    var _params;
    if (Object.is(params, undefined)) {
      _params = '';
    } else {
      _params = '?';
      for (var prop in params) {
        _params += "".concat(prop, "=").concat(params[prop], "&");
      }
    }
    return request.get(url + _params, {
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    }).then(function (r) {
      var content = r.data;
      var blob = new Blob([content]);
      if ('download' in document.createElement('a')) {
        var elink = document.createElement('a');
        elink.download = filename;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      } else {
        navigator.msSaveBlob(blob, filename);
      }
    }).catch(function (r) {
      console.error(r);
      Message({
        type: "error",
        message: "下载失败"
      });
    });
  },
  upload: function upload(url, params) {
    var formData = new FormData();
    for (var prop in params) {
      formData.append(prop, params[prop]);
    }
    return handleCustomErrorCode(request.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }));
  }
};
export default Rxports;